import { EquipmentDescriptionDisplay } from "./equipment-description-display.content";
import { SpeakersDisplay } from "./speakers-display.content";
import { TrainingLocationDisplay } from "./training-location-display.content";
import { VariantCard } from "./variant-card.content";
import type { ComplementaryInfoData } from "./types";

interface ComplementaryInfoCardProps {
  data: ComplementaryInfoData;
  variant: "admin" | "provider";
}

const DEFAULT_TITLES = {
  admin: "Informations complémentaires du prestataire",
  provider: "Informations complémentaires",
} as const;

export const ComplementaryInfoCard = ({ data, variant }: ComplementaryInfoCardProps) => {
  const title = DEFAULT_TITLES[variant];
  const hasPostalAddress = data.trainingLocation !== null;
  const hasEquipmentDescription = data.equipmentDescription !== null;
  const hasSpeakers = data.speakers && data.speakers.length > 0;

  if (!hasPostalAddress && !hasEquipmentDescription && !hasSpeakers) {
    return null;
  }

  return (
    <VariantCard title={title} variant={variant} contentClassName="space-y-2">
      {hasPostalAddress && data.trainingLocation && <TrainingLocationDisplay address={data.trainingLocation} />}
      {hasEquipmentDescription && data.equipmentDescription && <EquipmentDescriptionDisplay description={data.equipmentDescription} />}
      {hasSpeakers && data.speakers && <SpeakersDisplay speakers={data.speakers} />}
    </VariantCard>
  );
};
